const DETAIL_TITLE_PLACEHOLDER = /\[\[([^[\]]+)\]\]/g;

export const resolveDetailPageTitle = (
  template: string | null | undefined,
  values: Record<string, unknown> | undefined
): string =>
  (template ?? '').replace(DETAIL_TITLE_PLACEHOLDER, (_placeholder, fieldName: string) => {
    const value = values?.[fieldName];
    return value == null ? '' : String(value);
  });
